
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Description, Meta } from '@storybook/addon-docs';
import contributing from '../../CONTRIBUTING.md';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Contributing" mdxType="Meta" />
    <Description mdxType="Description">{contributing}</Description>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;

export const __page = () => { throw new Error("Docs-only story"); };

__page.parameters = { docsOnly: true };

const componentMeta = { title: 'Contributing', includeStories: ["__page"],  };

const mdxStoryNameToKey = {};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;